/**
 * @description Checks if the response is valid.
 *
 * @param {Response} response - The response object.
 * @returns {boolean} - true if the response status is 200 and ok property is true, otherwise false.
 */
export var isValidResponse = function (response) { return response && response.status === 200 && response.ok === true; };
//# sourceMappingURL=isValidResponse.js.map